import ReactStars from "react-rating-stars-component";

const StarRating = ({ rating, onChange }) => {
  return (
    <ReactStars
      count={5}
      value={rating}
      size={27}
      edit={true}          // must be true
      activeColor="#165EB3"
      onChange={onChange}  // pass function
    />
  );
};

export default StarRating;
